import { QuillConfig } from 'ngx-quill';

export const editorConf: QuillConfig = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],

      ['clean'], // remove formatting button

      ['link', 'image', 'video'], // link and image, video

      ['table'] // Add table control
    ],
    // preserveWhitespace: true,
    // formats: [
    //   'background',
    //   'bold',
    //   'color',
    //   'font',
    //   'code',
    //   'italic',
    //   'link',
    //   'size',
    //   'strike',
    //   'script',
    //   'underline',
    //   'blockquote',
    //   'header',
    //   'indent',
    //   'list',
    //   'align',
    //   'direction',
    //   'code-block',
    //   'formula'
    // ],
    table: {
      operationMenu: {
        items: {
          insertColumnRight: {
            text: 'Insert Column Right'
          },
          insertColumnLeft: {
            text: 'Insert Column Left'
          },
          insertRowUp: {
            text: 'Insert Row Above'
          },
          insertRowDown: {
            text: 'Insert Row Below'
          },
          deleteColumn: {
            text: 'Delete Column'
          },
          deleteRow: {
            text: 'Delete Row'
          }
        }
      }
    }
  },
  customOptions: [
    {
      import: 'formats/font',
      whitelist: ['mirza', 'roboto', 'aref', 'serif', 'sansserif', 'monospace']
    }
  ],
  sanitize: true
};
